import mobileAppRepository from '../repositories/mobileAppRepository';
import { APP_MOBILE } from '../utils/app_constants';

/**
 * Service layer for managing mobile app versions and rate plans.
 * Wraps repository calls and provides a clear API for controllers.
 */
const mobileAppService = {
  /**
   * Fetch app versions for a given OS and app name.
   */
  async getAppVersions({ osVersion, syncUpAppName }) {
    return mobileAppRepository.getAppVersions({ osVersion, syncUpAppName });
  },

  /**
   * Fetch rate plans for an app.
   */
  async getRatePlans({ syncUpAppName }) {
    return mobileAppRepository.getRatePlans({ syncUpAppName });
  },

  /**
   * Delete a rate plan by version ID and app name.
   */
  async deleteRatePlan({ ratePlanId, syncUpAppName }) {
    return mobileAppRepository.deleteRatePlan({ ratePlanId, syncUpAppName });
  },

  /**
   * Create a new rate plan.
   */
  async createRatePlan({ planName, product, version, syncUpAppName }) {
    const body = {
      planName,
      product,
      ...(syncUpAppName === APP_MOBILE.TRACKER ? { version } : {})
    };
    return mobileAppRepository.createRatePlan({ body, syncUpAppName });
  },

  /**
   * Delete app versions by version ID and app name.
   */
  async deleteAppVersions({ versionID, syncUpAppName }) {
    return mobileAppRepository.deleteAppVersions({ versionID, syncUpAppName });
  },

  /**
   * Create a new app version.
   */
  async postAppVersion({ body, syncUpAppName }) {
    return mobileAppRepository.postAppVersion({ body, syncUpAppName });
  },

  /**
   * Update an app version with additional metadata.
   */
  async updateAppVersions({
    body,
    syncUpAppName,
    distributionChannel,
    platform
  }) {
    return mobileAppRepository.updateAppVersion({
      body,
      syncUpAppName,
      distributionChannel,
      platform
    });
  }
};

export default mobileAppService;
